import { Communication } from '../components/communication';

export function GlobalCommunicationPage() {
  return <Communication />;
}
